import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import * as globals from '../../components/GlobalScripts.js';

import '../../styles/admin/platillos.css';

const TYPE_TABS = [
    { value: '', label: 'Todos' },
    { value: 'entrada', label: 'Ensaladas' },
    { value: 'fuerte', label: 'Platos fuertes' },
    { value: 'snack', label: 'Snacks' },
];

const STATUS_OPTIONS = [
    { value: 'all', label: 'Todos' },
    { value: 'active', label: 'Activos' },
    { value: 'inactive', label: 'Inactivos' },
];

function getPathApi() {
    return String(localStorage.getItem('path_api') || '').replace(/\/$/, '');
}

function safeJsonParse(maybeJson, fallback = {}) {
    try {
        if (typeof maybeJson === 'string') return JSON.parse(maybeJson);
        if (maybeJson && typeof maybeJson === 'object') return maybeJson;
    } catch { }
    return fallback;
}

function normalizePlatillo(row) {
    const r = row || {};
    const d = safeJsonParse(r.data, {});
    const nut = d.nutricion || {};
    const resumen = nut.resumen || nut;

    return {
        id: r.id ?? r.platillo_id ?? null,
        tipo: String(r.tipo || d.tipo || '').trim(),
        activo: Number(r.activo ?? d.activo ?? 1) ? 1 : 0,

        nombre: String(d.nombre || '').trim(),
        descripcion: String(d.descripcion || '').trim(),
        imagenes: Array.isArray(d.imagenes) ? d.imagenes.filter(Boolean).map(String) : [],

        kcal: Number(resumen.kcal || 0) || 0,
        p: Number(resumen.proteinas || resumen.proteinas_g || 0) || 0,
        c: Number(resumen.carbohidratos || resumen.carbohidratos_g || 0) || 0,
        g: Number(resumen.grasas || resumen.grasas_g || 0) || 0,

        alergeno: String(d.alergenos_disclaimer || '').trim(),

        created_at: r.created_at || null,
        updated_at: r.updated_at || null,
        data: d,
    };
}

function labelTipo(tipo) {
    const t = String(tipo || '').toLowerCase();
    if (t === 'entrada') return 'Ensaladas';
    if (t === 'fuerte') return 'Plato fuerte';
    if (t === 'snack') return 'Snack';
    return t ? t : 'Sin tipo';
}

function IconPlus(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
    );
}
function IconSearch(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="currentColor" strokeWidth="2" />
            <path d="M16.5 16.5 21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
function IconEdit(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M12 20h9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path
                d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4 11.5-11.5Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
            />
        </svg>
    );
}
function IconCopy(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M9 9h10v12H9V9Z" stroke="currentColor" strokeWidth="2" />
            <path
                d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}
function IconEye(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7S2.5 12 2.5 12Z"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" stroke="currentColor" strokeWidth="2" />
        </svg>
    );
}
function IconEyeOff(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M3 3l18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path
                d="M10.7 5.1A10.5 10.5 0 0 1 12 5c6 0 9.5 7 9.5 7a18 18 0 0 1-3 4.2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M6.1 6.1C3.8 8 2.5 12 2.5 12s3.5 7 9.5 7c1.4 0 2.7-.3 3.8-.8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path d="M10 10a3 3 0 0 0 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
function IconChevronLeft(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M15 18 9 12l6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
function IconChevronRight(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="m9 18 6-6-6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
function IconCheck(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M20 6 9 17l-5-5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
function IconRefresh(props) {
    return (
        <svg viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M20 12a8 8 0 1 1-2.3-5.7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
            <path d="M20 4v6h-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function AdminPlatillos() {
    const nav = useNavigate();

    const [loading, setLoading] = useState(false);

    const [draftQ, setDraftQ] = useState('');
    const [draftTipo, setDraftTipo] = useState('');
    const [draftStatus, setDraftStatus] = useState('active');
    const [draftLimit, setDraftLimit] = useState(12);

    const [appliedQ, setAppliedQ] = useState('');
    const [appliedTipo, setAppliedTipo] = useState('');
    const [appliedStatus, setAppliedStatus] = useState('active');
    const [appliedLimit, setAppliedLimit] = useState(12);

    const [page, setPage] = useState(1);

    const [items, setItems] = useState([]);
    const [paging, setPaging] = useState({ total: 0, total_pages: 1 });

    const busyRef = useRef(0);
    const busyWrap = async (fn) => {
        try {
            if (busyRef.current === 0) {
                globals.openViewCharge();
                await new Promise(requestAnimationFrame);
            }
            busyRef.current += 1;
            return await fn();
        } finally {
            busyRef.current = Math.max(0, busyRef.current - 1);
            if (busyRef.current === 0) globals.closeViewCharge();
        }
    };

    const total = Number(paging?.total || 0);
    const totalPages = Math.max(1, Number(paging?.total_pages || 1));

    const activeTab = useMemo(() => {
        const f = TYPE_TABS.find((t) => t.value === draftTipo);
        return f?.value ?? '';
    }, [draftTipo]);

    const hasPendingChanges = useMemo(() => {
        return (
            String(draftQ || '').trim() !== String(appliedQ || '').trim() ||
            String(draftTipo || '') !== String(appliedTipo || '') ||
            String(draftStatus || 'active') !== String(appliedStatus || 'active') ||
            Number(draftLimit || 12) !== Number(appliedLimit || 12)
        );
    }, [draftQ, draftTipo, draftStatus, draftLimit, appliedQ, appliedTipo, appliedStatus, appliedLimit]);

    const applyFilters = () => {
        setAppliedQ(String(draftQ || '').trim());
        setAppliedTipo(String(draftTipo || '').trim());
        setAppliedStatus(String(draftStatus || 'active'));
        setAppliedLimit(Number(draftLimit) || 12);
        setPage(1);
    };

    const resetFilters = () => {
        setDraftQ('');
        setDraftTipo('');
        setDraftStatus('active');
        setDraftLimit(12);

        setAppliedQ('');
        setAppliedTipo('');
        setAppliedStatus('active');
        setAppliedLimit(12);

        setPage(1);
    };

    const fetchList = async () => {
        const path_api = getPathApi();
        const session_id = globals.get_session_id();
        const keylogin = globals.get_keylogin();

        setLoading(true);

        const activo = appliedStatus === 'active' ? 1 : appliedStatus === 'inactive' ? 0 : null;

        const payload = {
            rute: globals.getRuteBackend(),
            session_id,
            keylogin,
            q: String(appliedQ || '').trim(),
            tipo: String(appliedTipo || '').trim(),
            activo,
            page,
            limit: appliedLimit,
        };

        try {
            await busyWrap(async () => {
                const response = await axios.post(`${path_api}/admin/platillos/list.php`, payload);

                if (response.data?.mensaje === 'success') {
                    const rawItems = response.data?.items || [];
                    const norm = Array.isArray(rawItems) ? rawItems.map(normalizePlatillo) : [];
                    const p = response.data?.paging || {};

                    setItems(norm);
                    setPaging({
                        total: Number(p.total || response.data?.total || 0) || 0,
                        total_pages: Number(p.total_pages || response.data?.total_pages || 1) || 1,
                    });
                    return;
                }

                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: response.data?.mensaje || 'No se pudo cargar el catálogo',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });

                setItems([]);
                setPaging({ total: 0, total_pages: 1 });
            });
        } catch (e) {
            console.error(e);
            globals.createAlert({
                type: 'error',
                msg_title: 'Error',
                msg: 'Error al cargar el catálogo',
                effect: 'opacidad 2s, desplazamiento 2s',
                time_life: 4000,
            });
            setItems([]);
            setPaging({ total: 0, total_pages: 1 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, [appliedQ, appliedTipo, appliedStatus, appliedLimit, page]);

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyFilters();
        }
    };

    const handleToggleActive = async (it) => {
        const path_api = getPathApi();

        const payload = {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: it.id,
            activo: it.activo ? 0 : 1,
        };

        try {
            await busyWrap(async () => {
                const response = await axios.post(`${path_api}/admin/platillos/toggle.php`, payload);

                if (response.data?.mensaje === 'success') {
                    globals.createAlert({
                        type: 'success',
                        msg_title: 'Listo',
                        msg: payload.activo ? 'Platillo activado' : 'Platillo inactivado',
                        effect: 'opacidad 1s, desplazamiento 1s',
                        time_life: 1800,
                    });
                    fetchList();
                    return;
                }

                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: response.data?.mensaje || 'No se pudo actualizar el estado',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            });
        } catch (e) {
            console.error(e);
            globals.createAlert({
                type: 'error',
                msg_title: 'Error',
                msg: 'Error al actualizar estado',
                effect: 'opacidad 2s, desplazamiento 2s',
                time_life: 4000,
            });
        }
    };

    return (
        <div className="tw-platillos-page">
            <div className="tw-platillos-shell">
                <div className="tw-platillos-topbar">
                    <div>
                        <div className="tw-platillos-title">Platillos</div>
                        <div className="tw-platillos-subtitle">
                            Administra platillos con nutrición completa, alérgenos e imágenes.
                        </div>
                    </div>

                    <div className="tw-platillos-actions">
                        <button className="tw-platillos-btn tw-platillos-btn--primary" type="button" onClick={() => nav('/admin/platillos/nuevo')}>
                            <IconPlus />
                            Nuevo platillo
                        </button>
                    </div>
                </div>

                <div className="tw-platillos-toolbar">
                    <div className="tw-platillos-toolbar-top">
                        <div>
                            <div className="tw-platillos-label">Buscar</div>
                            <div className="tw-platillos-search">
                                <IconSearch />
                                <input
                                    className="tw-platillos-input"
                                    value={draftQ}
                                    onChange={(e) => setDraftQ(e.target.value)}
                                    onKeyDown={handleSearchKeyDown}
                                    placeholder="Nombre, descripción…"
                                />
                            </div>
                            <div className="tw-platillos-hint">Presiona Enter o “Aplicar”.</div>
                        </div>

                        <div>
                            <div className="tw-platillos-label">Estado</div>
                            <select className="tw-platillos-control" value={draftStatus} onChange={(e) => setDraftStatus(e.target.value)}>
                                {STATUS_OPTIONS.map((o) => (
                                    <option key={o.value} value={o.value}>
                                        {o.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <div className="tw-platillos-label">Por página</div>
                            <select className="tw-platillos-control" value={String(draftLimit)} onChange={(e) => setDraftLimit(Number(e.target.value) || 12)}>
                                <option value="9">9</option>
                                <option value="12">12</option>
                                <option value="18">18</option>
                                <option value="24">24</option>
                            </select>
                        </div>

                        <div className="tw-platillos-applybox">
                            <button
                                className="tw-platillos-btn tw-platillos-btn--ghost"
                                type="button"
                                onClick={resetFilters}
                                disabled={loading}
                                title="Restablecer filtros"
                            >
                                <IconRefresh />
                                Reset
                            </button>

                            <button
                                className="tw-platillos-btn tw-platillos-btn--apply"
                                type="button"
                                onClick={applyFilters}
                                disabled={!hasPendingChanges || loading}
                                title="Aplicar filtros"
                            >
                                <IconCheck />
                                Aplicar
                            </button>
                        </div>
                    </div>

                    <div className="tw-platillos-toolbar-bottom">
                        <div className="tw-platillos-chips">
                            {TYPE_TABS.map((t) => (
                                <button
                                    key={t.value || 'all'}
                                    className={`tw-platillos-chip ${activeTab === t.value ? 'tw-platillos-chip--active' : ''}`}
                                    type="button"
                                    onClick={() => setDraftTipo(t.value)}
                                >
                                    {t.label}
                                </button>
                            ))}
                        </div>

                        <div className="tw-platillos-meta">
                            {loading ? 'Cargando…' : total ? `Total: ${total} | Página ${page}/${totalPages}` : `${items.length} resultados`}
                            {hasPendingChanges ? ' • Filtros sin aplicar' : ''}
                        </div>
                    </div>
                </div>

                {items.length === 0 && !loading ? (
                    <div className="tw-platillos-empty">No hay platillos con los filtros actuales. Crea uno nuevo para comenzar.</div>
                ) : (
                    <div className="tw-platillos-grid">
                        {items.map((it) => {
                            const cover = it.imagenes?.[0] || '';
                            return (
                                <div key={String(it.id ?? it.nombre)} className={`tw-platillos-card ${it.activo ? '' : 'tw-platillos-card--inactive'}`}>
                                    <div className="tw-platillos-cover">
                                        {cover ? <img src={cover} alt={it.nombre} /> : null}

                                        <div className="tw-platillos-cover-badges">
                                            <div className="tw-platillos-badge">{labelTipo(it.tipo)}</div>
                                            <div className={`tw-platillos-badge ${it.activo ? 'tw-platillos-badge--active' : 'tw-platillos-badge--inactive'}`}>
                                                {it.activo ? 'Activo' : 'Inactivo'}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="tw-platillos-body">
                                        <div className="tw-platillos-cardhead">
                                            <div className="tw-platillos-name" title={it.nombre}>
                                                {it.nombre || 'Sin nombre'}
                                            </div>

                                            <div className="tw-platillos-actions-mini">
                                                <button
                                                    className="tw-platillos-iconbtn"
                                                    type="button"
                                                    title="Editar"
                                                    onClick={() => nav(`/admin/platillos/${it.id}/editar`)}
                                                    aria-label="Editar"
                                                >
                                                    <IconEdit />
                                                </button>

                                                <button
                                                    className="tw-platillos-iconbtn"
                                                    type="button"
                                                    title="Clonar"
                                                    onClick={() => nav(`/admin/platillos/${it.id}/clonar`)}
                                                    aria-label="Clonar"
                                                >
                                                    <IconCopy />
                                                </button>

                                                <button
                                                    className="tw-platillos-iconbtn"
                                                    type="button"
                                                    title={it.activo ? 'Inactivar' : 'Activar'}
                                                    onClick={() => handleToggleActive(it)}
                                                    aria-label="Estado"
                                                >
                                                    {it.activo ? <IconEyeOff /> : <IconEye />}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="tw-platillos-desc">{it.descripcion || '—'}</div>

                                        <div className="tw-platillos-macros">
                                            <div className="tw-platillos-pill">{Math.round(it.kcal)} Kcal</div>
                                            <div className="tw-platillos-pill">P {Math.round(it.p)}g</div>
                                            <div className="tw-platillos-pill">C {Math.round(it.c)}g</div>
                                            <div className="tw-platillos-pill">G {Math.round(it.g)}g</div>
                                        </div>

                                        <div className="tw-platillos-allergen">
                                            {it.alergeno ? it.alergeno : 'Sin disclaimer de alérgenos (recomendado agregar).'}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                <div className="tw-platillos-footer">
                    <div className="tw-platillos-meta">{total ? `Página ${page} de ${totalPages}` : `Página ${page}`}</div>

                    <div className="tw-platillos-pagination">
                        <button
                            className="tw-platillos-pagebtn"
                            type="button"
                            onClick={() => setPage((p) => Math.max(1, p - 1))}
                            disabled={page <= 1}
                            aria-label="Anterior"
                        >
                            <IconChevronLeft />
                        </button>

                        <div className="tw-platillos-pagelabel">
                            {page} / {totalPages}
                        </div>

                        <button
                            className="tw-platillos-pagebtn"
                            type="button"
                            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                            disabled={page >= totalPages}
                            aria-label="Siguiente"
                        >
                            <IconChevronRight />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
